import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';

const Static = ({ horizontal, labelCol = 3, valueCol = 9, input: { value }, label, required, help, meta: { touched, error, warning }, ...props }) => {
	const validationState = touched && (error && 'error') || (warning && 'warning') || null;
	const formControl = <FormControl.Static>{value}</FormControl.Static>;
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

	if (horizontal) {
		return (
			<FormGroup className='row'>
				<Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>
				<Col sm={valueCol}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			<ControlLabel>{label}{labelHint}</ControlLabel>
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

Static.propTypes = {
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	value: PropTypes.string,
};

export default Static;